import Axios from 'axios';
import { setDefaultCorrelationContext } from './correlationContext';

setDefaultCorrelationContext();

export { default as axios } from './axios';
export {
  setCorrelationContext,
  setDefaultCorrelationContext
} from './correlationContext';
export { default as getAxiosAuthHeader } from './getAxiosAuthHeader';
export { default as httpWithAuth } from './httpWithAuth';
export { default as isAxiosError } from './isAxiosError';

export const { Cancel, CancelToken } = Axios;

export type { AxiosError, Canceler } from 'axios';
